/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-19 17:44:00
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-10-16 10:18:33
 */
import { getDictItemAllList } from "./api-basic";
import config from "@/config/config";
import { objAny } from "@/common/common-interface";
/**
 * 获取字典用的 KEYk
 */
export const optionKey = {
  auxPowerList: "104", //辅助电源
  devTypeList: "102", //充电桩类别
  innerIdList: "185", //充电桩接口标准
  pushStatusList: "103", //推送状态
  httpList: "107", //对接方式
  getList: "108", //请求方式
  spearTypeList: "1018", //接口类型
  clientList: "1017", //客户名称
  isShowObj: "1019", //公众号显示
  networkObj: "1020", //联网状态
  autotrophyObj: "156", //运营属性
  staStatusObj: "153", //充电站状态
  csTypeObj: "154", //充电站类型
  orderStatusObj: "155", //充电订单状态
  orderTypeObj: "12377", //充电订单类型
  tagObj: "1016", //站点标签
  suppoertOrderObj: "1021", //支持预约
  allDayDisparkObj: "1022", //全天开放
  freeParkObj: "1023", //免费停车
  paymentObj: "1024", //支付方式
  messageTypeList: "1030", //短信类型
  cardStatusList: "159", //sim 卡运行状态
  provideList: "160", //sim 供应商
  cardStatusObj: "1033", //sim 状态
  roleTypeObj: "1069", //角色类型
  queryTypeList: "1076", //非实名卡状态
  netDriectionObj: "12367", //互通方向
  netTypeObj: "12368", //互通类型
  netStatus: "12366", //互通状态
  defaultAbnormalOrderList: "12374", //异常处理类型
  applyStatusList: "12373 ", //审核类型
  userTypeObj: "12365", //系统用户类型
  noticeStatusObj: "12382", //系统用户类型
  simCardFlowList: "12383", //sim 套餐
  noticeTypeObj: "12363", //系统用户类型
  objectTypeObjChecking: "12379", //系统用户类型
  couponTypeObj: "12384", //优惠券类型
  applyStatusObj: "12386", //营销活动审核状态
  campaignTypeObj: "12388", //营销活动类型
  campaignStatusObj: "12389", //营销活动状态
  chargeModeObj: "12391", //充电模式
  dealTypeObj: "12392", //报告处理类型
  staApplyStatusObj: "12393", //站点审核状态
  invoiceTypeList: "12407", // 发票类型
  orderStatusList: "12408", // 提现单状态
  orderStatusTodayList: "12409", // 日结单状态,
  invoiceTypeObj: "12413", //发票类型
  alarmLevel: "12455", // 告警状态
  alarmStatus: "12410", // 告警等级
  alarmType: "12456", // 告警类型
  chargingModeObj: "12511", // 充电方式
  modeType: "1065" // 分成方式
};
/**
 * @author: 陈钊贤
 * @description: 获取字典信息 typeIds是数组, 里面是 optionKey 对应的ID
 * @param {typeIds}
 * @return: Promise
 */
export const getOptionList = async (typeIds: string[]): Promise<objAny> => {
  const ret = await getDictItemAllList({
    typeIdList: typeIds
  });
  return new Promise<objAny>(resolve => {
    if (ret.status === config.apiStatus) {
      const list = ret.data;
      const obj: objAny = {};
      const language = localStorage.getItem("language") || "";
      typeIds.map(typeId => {
        list.map((item: objAny) => {
          if (item.typePkId == typeId) {
            if (!obj[typeId]) {
              obj[typeId] = [];
            }
            item.label = item.i18nItemValue;
            item.itemValue = item.i18nItemValue;
            item.value = item.itemKey;
            obj[typeId].push(item);
          }
        });
      });
      resolve(obj);
    }
  });
};
